module.exports = __webpack_public_path__ + "img/img4-bg.bddab3c5.png";